import apiClient from '@shared/api/client';
import { ENDPOINTS } from '@shared/api/endpoints';

/**
 * 飄落彩蛋抽獎（點擊蓮花/菩提葉加分）相關 API
 */

// 取得抽獎狀態（是否有可領取的獎勵）
export async function getLotteryStatus() {
    return apiClient.get(ENDPOINTS.LOTTERY.STATUS);
}

// 領取獎勵（加分）。lotteryId、key 由 status 回應提供
export async function claimLotteryReward(lotteryId, key) {
    return apiClient.post(ENDPOINTS.LOTTERY.CLAIM, {
        lottery_id: Number(lotteryId),
        key,
    });
}
